import S3PhotoModel from './S3PhotoModel';

export default class AdminViewCounselorModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || data.counselor_id || 0;
    this.user_id = data.user_id || 0;
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.email = data.email || '';
    this.on_campus_counselor = data.on_campus_counselor || '';
    this.date_joined = data.date_joined ? new Date(data.date_joined) : null;
    this.last_login = data.last_login ? new Date(data.last_login) : null;
    this.school_name = data.school_name || '';
    this.verified = data.verified;
    this._is_active = data._is_active || false;
    this.calendar_initialized = data.calendar_initialized;
    this._has_set_working_hours = data.has_set_working_hours || null;
    this.registered_in_states_short_names = data.registered_in_states_short_names || [];
    this.pending_requests = data.pending_requests;
    this.approved_requests = data.approved_requests;
    this.denied_requests = data.denied_requests;
    this.canceled_requests = data.canceled_requests;
    this.expired_requests = data.expired_requests;
    this.canceled_appointments = data.canceled_appointments;
    this.canceled_by_counselor_appointments = data.canceled_by_counselor_appointments;
  }

  get name() {
    return `${this.first_name} ${this.last_name}`;
  }

  get display_label() {
    if (this.email) {
      return `${this.name} (${this.email})`;
    }

    return `${this.name} - ${this.school_name || 'No School'}`;
  }

  get has_set_working_hours() {
    if (this._has_set_working_hours) {
      return 'Yes';
    } else {
      return 'No';
    }
  }

  get _photo() {
    return this.photo;
  }

  get status() {
    if (!this._is_active) {
      return 'Inactive';
    }

    if (this.verified) {
      return 'Verified';
    }
    return 'Not Verified';
  }
}
